// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-container {
  flex-direction: wrap;
  margin-top: 10px;
  position: center;
  text-align: left; /* Add this line to left-align the text */
}

.checkbox-container label {
  margin-bottom: 5px;
  align-items: center;
}

.checkbox-container input {
  margin-right: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/listen/finanzamt/finanzamt.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".checkbox-container {\n  flex-direction: wrap;\n  margin-top: 10px;\n  position: center;\n  text-align: left; /* Add this line to left-align the text */\n}\n\n.checkbox-container label {\n  margin-bottom: 5px;\n  align-items: center;\n}\n\n.checkbox-container input {\n  margin-right: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
